<div class="h-full flex flex-col">
    <div class="w-full h-full flex flex-col justify-around">
        <div class="gradient-container relative flex flex-col items-center justify-around gap-2 mt-4">
            <div class="gradient-background"></div>
            <div class="flex p-[0.15rem] rounded-xl border border-arena-orange-100 bg-arena-orange-50/1 relative z-10">
                <div class="">
                    <div class="flex p-4 border bg-white rounded-xl">
                        <div class="flex items-center justify-center gap-2">
                            <img width="30" height="30" [src]="'images/logos/microsoft-azure.png' | assetUrl"
                                alt="Azure logo">
                            <span class="text-lg font-medium">Microsoft Azure</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex flex-col items-center space-y-1.5 relative z-10">
                @for(dot of dots; track $index){
                <div class="h-1 w-1 rounded-full bg-orange-400/80"></div>
                }
            </div>
            <div class="flex p-[0.15rem] rounded-xl border border-arena-orange-100 bg-arena-orange-50/1 relative z-10">
                <div class="">
                    <div class="flex p-4 border bg-white rounded-xl">
                        <img width="100" [src]="'images/logos/innDocAI-themed.png' | assetUrl" alt="InnDoc logo">
                    </div>
                </div>
            </div>


        </div>
        @if(isLoadingConsentStatus){
        <div class="flex flex-col items-center gap-2">
            <div class="flex items-center justify-center gap-2">
                <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-arena-orange-500"></div>
                <span class="text-gray-600 text-sm">Loading consent status...</span>
            </div>
        </div>
        } @else if(lastSynced){
        <div class="flex flex-col items-center gap-2">
            <div class="px-1.5 rounded-lg py-1"
                [ngClass]="{'bg-green-100': consentExists, 'bg-red-100': !consentExists}">
                <span class="font-medium px-2"
                    [ngClass]="{'text-green-700': consentExists, 'text-red-700': !consentExists}">{{ !consentExists ?
                    'Disconnected' : 'Connected' }}</span>
            </div>
            @if(consentExists && usersCount > 0){
            <div class="px-1.5 bg-blue-100 rounded-lg ">
                <span class="text-blue-700 font-medium">Total Users : {{ usersCount }}</span>
            </div>
            }
        </div>
        }
        <div class="flex flex-col gap-3 mt-6">
            @if (!consentExists && !isLoadingConsentStatus) {
            <!-- Connect Button -->
            <div class="flex justify-center">
                <app-button label="Connect" [size]="'lg'" [loading]="isConnecting" severity="primary"
                    (clicked)="connectMicrosoft()" />
            </div>

            <!-- Info Text -->
            <div class="flex gap-2 text-sm text-gray-600 text-center items-center justify-center">
                <i class="pi pi-info-circle"></i>
                <span>Clicking "Connect" will open a popup to grant Microsoft Azure permissions</span>
            </div>
            } @else if(consentExists && !isLoadingConsentStatus) {
            <!-- Connected Actions -->
            <div class="flex gap-3 justify-center items-center">
                <app-button label="Sync Users" severity="primary" styleClass="flex-1" [icon]="'pi pi-sync'"
                    [iconSource]="'primeng'" (clicked)="syncUsers()" />

                <app-button label="Disconnect" severity="contrast" variant="outlined" styleClass="flex-1"
                    (clicked)="disconnectMicrosoft()" />
            </div>
            }
        </div>
    </div>
</div>
